import { __decorate } from "tslib";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { AflaCommonComponent } from "./afla-common.component";
import { ZaesriAngularCalciteModule } from "../../../zaesri-angular-calcite/src/lib/zaesri-angular-calcite.module";
import { CommonTableComponent } from "./components/common-table/common-table.component";
import { CommonTableSortHeaderDirective } from "./directives/common-table-sort-header.directive";
import { CommonFilterByComponent } from "./components/common-filter-by/common-filter-by.component";
import { FormsModule } from "@angular/forms";
import { NgPipesModule } from "ngx-pipes";
import { CommonModule } from "@angular/common";
import { HighlightWithColumnPipe } from "./pipes/highlight/highlight-with-column.pipe";
import { CommonDropDownComponent } from "./components/common-drop-down/common-drop-down.component";
import { CommonPopUpComponent } from "./components/common-pop-up/common-pop-up.component";
import { CommonSecondaryButtonComponent } from "./components/common-secondary-button/common-secondary-button.component";
import { CommonPrimaryButtonComponent } from "./components/common-primary-button/common-primary-button.component";
let AflaCommonModule = class AflaCommonModule {
};
AflaCommonModule = __decorate([
    NgModule({
        schemas: [CUSTOM_ELEMENTS_SCHEMA],
        declarations: [
            AflaCommonComponent,
            CommonTableComponent,
            CommonFilterByComponent,
            CommonDropDownComponent,
            CommonTableSortHeaderDirective,
            HighlightWithColumnPipe,
            CommonPopUpComponent,
            CommonPrimaryButtonComponent,
            CommonSecondaryButtonComponent
        ],
        imports: [
            ZaesriAngularCalciteModule,
            FormsModule,
            NgPipesModule,
            CommonModule
        ],
        exports: [
            AflaCommonComponent,
            CommonTableComponent,
            CommonDropDownComponent,
            CommonFilterByComponent,
            CommonTableSortHeaderDirective,
            CommonPopUpComponent,
            CommonPrimaryButtonComponent,
            CommonSecondaryButtonComponent
        ]
    })
], AflaCommonModule);
export { AflaCommonModule };
